import styled from 'styled-components';

export const MessageContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
`;

export const MessageBubble = styled.div`
  background: #e8ebfa;
  padding: 6px 12px;
  border-radius: 3px;
  max-width: 354px;
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #242424;
  text-align: right;

  @media (max-width: 768px) {
    max-width: 90%;
    font-size: 13px;
  }

  @media (max-width: 480px) {
    max-width: 100%;
  }
`;

